import {
  useDirection,
  type UseDirectionReturn,
} from '@/composables/useDirection';
import { DirectionMapboxProfile } from '@/models/enums';

export type UseWalkingDirectionReturn = UseDirectionReturn;

/**
 * Returns the distance, duration and coordinates of a direction between two points by walking
 */
export function useWalkingDirection(
  from: Ref<Coordinates | null>,
  to: Ref<Coordinates | null>
): UseWalkingDirectionReturn {
  const { distance, duration, coordinates } = useDirection(
    from,
    to,
    DirectionMapboxProfile.Walking
  );

  return {
    distance,
    duration,
    coordinates,
  };
}
